import { ref } from 'vue'

export const useSlider = () => {
  const slider = ref<HTMLElement | null>(null)
  const isDragging = ref(false)
  const startX = ref(0)
  const scrollLeft = ref(0)

  function onMouseDown(e: MouseEvent) {
    if (!slider.value) return
    isDragging.value = true
    startX.value = e.pageX - slider.value.offsetLeft
    scrollLeft.value = slider.value.scrollLeft
  }

  const onMouseUp = () => {
    isDragging.value = false
  }

  function onMouseMove(e: MouseEvent) {
    if (!slider.value) return
    if (!isDragging.value) return
    e.preventDefault()
    const x = e.pageX - slider.value.offsetLeft
    const walk = x - startX.value
    slider.value.scrollLeft = scrollLeft.value - walk
  }

  return {
    onMouseDown,
    onMouseUp,
    onMouseMove,
    slider,
  }
}